var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgButtonQuest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 28,
    viewBox: "0 0 8 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00182 21.0993C5.69082 21.0993 7.06282 22.4703 7.06282 24.1603C7.06282 25.8493 5.69082 27.2203 4.00182 27.2203C2.31282 27.2203 0.940823 25.8493 0.940823 24.1603C0.940823 22.4703 2.31282 21.0993 4.00182 21.0993ZM3.98482 17.8883C3.26182 17.8803 2.54182 17.3413 2.25282 16.2713C0.355823 9.25132 0.139823 4.64432 0.940823 2.31832C1.10682 1.83632 1.75682 0.776323 4.00182 0.778323C6.24682 0.779323 6.89782 1.84032 7.06282 2.31832C7.86382 4.64432 7.64782 9.25132 5.75082 16.2713C5.45982 17.3493 4.73082 17.8883 4.00182 17.8883H3.98482Z",
    fill: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonQuest);
export default __webpack_public_path__ + "static/media/button_quest.8a2c215af625eba7b9491936fe33e0da.svg";
export { ForwardRef as ReactComponent };